export default function logger(...args) {
  window.dispatchEvent(new CustomEvent('logger', { detail: args }));
}
